var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.orders.currentOrder)?_c('div',[_c('Header'),(_vm.user)?_c('main',{staticClass:"tracker__main"},[_c('div',{staticClass:"tracker__mainContent"},[_c('contentInfoTracker'),_c('contentResumentTracker')],1)]):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }